(function () {
    'use strict';

    angular
        .module('BCMControllers')
        .controller('BIAProfileEditController', Controller);

    Controller.$inject = ['$scope', 'biaProfileContainer', 'biaResponsibilities', 'bcmLookups', 'followUps'];

    function Controller($scope, biaProfileContainer, biaResponsibilities, bcmLookups, followUps) {

        $scope.biaProfile = biaProfileContainer.BIAProfile;
        $scope.biaBuOwners = biaProfileContainer.BIABUOwners;
        $scope.biaResponsibilities = biaResponsibilities;
        $scope.bcmLookups = bcmLookups;
        $scope.followUps = followUps;
    }
})();